<template>

  <div class="w-full sm:flex sm:flex-wrap sm:items-center md:justify-between bg-lu-gray-dark px-4 py-2">
    <div class="w-full sm:w-1/2 md:w-3/4 flex-col justify-center">
      <div class="w-full flex flex-col md:flex-row items-center sm:items-start" v-if="links.length > 0">
        <a
          v-for="(link, index) in links"
          v-bind:key="index"
          :href="link.link"
          class="text-sm sm:text-xs border-dotted border-b sm:mt-0 text-white hover:border-solid"
          :class="index > 0 ? 'mt-1 sm:mt-0 md:ml-4' : ''"
        >{{ link.text }}</a>
      </div>
      <div class="sm:w-full flex justify-center sm:justify-start" :class="links.length ? 'mt-2 md:mt-4': ''">
        <p class="text-xs text-white">&copy; {{ copyright.holder }} {{ copyright.year }}</p>
      </div>
    </div>
    <div class="flex justify-center sm:w-1/2 md:w-1/4 sm:justify-end mt-2 sm:mt-0">
      <img class="h-10 lg:h-12" :src="logo.url" :alt="logo.alt" />
    </div>
  </div>

</template>

<script>
export default {
  name: 'LegalFooter',
  props: {
    links: {
      type: Array,
      default: () => {
        return []
      }
    },
    logo: {
      type: Object,
      default: () => {
        return {
          'url': require('../assets/library-white.png'),
          'alt': 'Lancaster University Library Logo'
        }
      }
    },
    copyright: {
      type: Object,
      default: () => {
        return {
          'holder': 'Lancaster University Library',
          'year': '2019'
        }
      }
    }
  }
}
</script>

<style>
  /* purgecss start ignore */
  @tailwind  base;
  @tailwind  components;
  /* purgecss end ignore */

  @tailwind utilities;

</style>
